import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autocomplete-breeds"
export default class extends Controller {
  static targets = [
    'input',
    'results'
  ]

  connect() {
    this.resultsTarget.hidden = true
  }

  search() {
    const query = this.inputTarget.value;
    if (query.length < 2) {
      this.resultsTarget.innerHTML = "";
      return;
    }

    fetch(`/breeds/autocomplete.json?term=${query}`)
      .then(response => response.json())
      .then(data => {
        if (data.length > 0) {
          this.resultsTarget.hidden = false
          data.forEach(option => {
            const li = document.createElement('li')
            li.textContent = option
            li.dataset.action = 'click->autocomplete-breeds#select'
            this.resultsTarget.appendChild(li)
          })
        } else {
          this.resultsTarget.hidden = true
        }
    });
  }

  select(event) {
    this.inputTarget.value = event.target.textContent
    this.resultsTarget.hidden = true
  }
}
